import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
// import createIdbStorage from 'redux-persist-indexeddb-storage';
import storage from 'redux-persist/lib/storage/session';
import RootReducer from './slices/root-reducer'

// Create IndexedDB storage instance for large data handling
// const storage = createIdbStorage({
//   name: 'revamp-acs-db', // IndexedDB database name
//   storeName: 'revamp-acs-store', // Object store name
// });

const persistConfig = {
  key: 'root',
  storage,
  transforms: [
    encryptTransform({
      secretKey: process.env.REACT_APP_REDUX_KEY,
      onError: (e) => console.error("encryptTransform", e),
    }),
  ],
  whitelist: ['loginUserReducer', 'ReportCatalogReducer'], // Add reducers you want to persist
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false, // disable immutability check
      serializableCheck: false, // optional: disable serializable check too
      // serializableCheck: {
      //   ignoredActions: ['persist/PERSIST'], // Ignore the PERSIST action
      //   ignoredPaths: ['register'], // If `register` is part of the state, ignore it
      // },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
